export default __webpack_public_path__ + "static/media/booking_confirmed.6b859ce3.svg";